import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['radio', 'submit', 'label']

  connect() {
    this.checkSelection()
    // Attach event listeners directly to submit buttons to handle disabled state
    this.submitTargets.forEach((submit) => {
      // Use pointerdown which is more reliable than mousedown on disabled elements
      submit.addEventListener(
        'pointerdown',
        this.handleSubmitClick.bind(this),
        { passive: false }
      )
      submit.addEventListener('mousedown', this.handleSubmitClick.bind(this), {
        passive: false
      })
    })
  }

  disconnect() {
    // Clean up event listeners
    this.submitTargets.forEach((submit) => {
      submit.removeEventListener(
        'pointerdown',
        this.handleSubmitClick.bind(this)
      )
      submit.removeEventListener('mousedown', this.handleSubmitClick.bind(this))
    })
  }

  handleInput(event) {
    const label = event.currentTarget
    const radioId = label.getAttribute('for')
    const radio = document.getElementById(radioId)

    if (!radio || !radio.checked) return

    // Handle spacebar inputs
    if (event.type === 'keydown' && event.key === ' ') {
      event.preventDefault()
      radio.checked = !radio.checked
      this.checkSelection()
    }
    // Handle click inputs
    else if (event.type === 'click') {
      const interactive = event.target.closest(
        'button, [role="button"], a, input, textarea, select'
      )
      if (interactive) return

      if (radio.checked) {
        event.preventDefault()
        radio.checked = false
      }
      this.checkSelection()
    }
  }

  // The answer label only covers its own text/letter, so the card's edges
  // (e.g. the margin around the guidance toggle) aren't part of any clickable
  // element. Forward clicks that land on that empty card space to the label,
  // skipping anything already interactive (the label itself, the guidance
  // panel, buttons, links, form controls).
  handleContainerClick(event) {
    const interactive = event.target.closest(
      'label, .guidance, button, [role="button"], a, input, textarea, select'
    )
    if (interactive) return

    const label = event.currentTarget.querySelector(
      '[data-selection-target="label"]'
    )
    label?.click()
  }

  handleSubmitClick(event) {
    // Check if the button is disabled
    const button = event.currentTarget || event.target
    if (button && button.disabled) {
      event.preventDefault()
      event.stopPropagation()
      const errorElement = document.getElementById('question-error')
      if (errorElement) {
        errorElement.classList.remove('hidden')
      }
    }
  }

  checkSelection() {
    const isSelected = this.radioTargets.some((radio) => radio.checked)

    this.submitTargets.forEach((submit) => {
      submit.disabled = !isSelected
      submit.setAttribute('aria-disabled', !isSelected)
    })

    // Hide error when a selection is made
    if (isSelected) {
      const errorElement = document.getElementById('question-error')
      if (errorElement) {
        errorElement.classList.add('hidden')
      }
    }
  }
}
